
export default function Home() {
  return (
    <section id='home' className='relative w-full h-[100vh] md:h-[110vh] overflow-hidden'>
      {/* Static Background Image */}
      <img
        src='/assets/heroImages/mainEducation.webp'
        alt='Arieri Hero Background'
        loading='lazy'
        className='absolute inset-0 w-full h-full object-cover z-0'
        style={{ minHeight: '100%', minWidth: '100%' }}
      />
      {/* Overlay */}
      <div className='absolute inset-0 bg-black/50 z-0'></div>

      {/* Content Overlay */}
      <div className='relative z-10 h-full flex flex-col justify-center items-start pl-6 md:pl-32 pr-8'>
        <h1 className='text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-comfortaa font-bold mb-4 text-left drop-shadow-lg bg-gradient-to-r from-green-500 to-green-300 text-transparent bg-clip-text'>
          Welcome to Arieri's World
        </h1>
        <p className='text-lg font-light sm:text-xl md:text-2xl mb-8 text-left max-w-xl text-white drop-shadow-lg'>
          Delivering diverse solutions that touch lives and solve real problems.
        </p>
        <div className='flex flex-col sm:flex-row gap-3'>
          <a
            href='/services/'
            className='group inline-flex items-center justify-start bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-full text-lg sm:px-6 sm:py-3 sm:text-base font-semibold shadow-lg transition-all duration-300 transform hover:scale-105 text-left'
          >
            Learn More
          </a>
          <a
            href='/request-quote'
            className='group inline-flex items-center justify-start border-2 border-white text-white hover:bg-white hover:text-green-700 px-8 py-4 rounded-full text-lg sm:px-6 sm:py-3 sm:text-base font-semibold transition-all duration-300 text-left backdrop-blur-sm'
          >
            Get Started
          </a>
        </div>
      </div>
    </section>
  )
}
